function isVideoDebugEnabled(): boolean {
  if (typeof window === "undefined") return false;

  try {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get("videoDebug") === "1" ||
      params.get("devDebug") === "1" ||
      window.localStorage.getItem("dentalAvatarVideoDebug") === "1" ||
      window.localStorage.getItem("dentalAvatarDevDebug") === "1"
    );
  } catch {
    return false;
  }
}

export function videoDebugLog(...args: unknown[]): void {
  if (isVideoDebugEnabled()) {
    console.log(...args);
  }
}

export function videoDebugWarn(...args: unknown[]): void {
  if (isVideoDebugEnabled()) {
    console.warn(...args);
  }
}

export function videoDebugError(...args: unknown[]): void {
  if (isVideoDebugEnabled()) {
    console.error(...args);
  }
}
